export default "/images/6e54ad38c3f9e0c5ca7dfbd8e40d02dc.jpg";